import {
    Vector2
} from 'three';

/**
 * Dot screen shader
 * based on glfx.js sepia shader
 * https://github.com/evanw/glfx.js
 */

const custom = {

    uniforms: {

        'tDiffuse': { value: null },
        'tSize': { 'height ': 500.0, 'width': 500 },
        'scale': { value: 1.5 },
        'progress': { value: 0.0 },

        'time': { value: 0.0 }

    },

    vertexShader: /* glsl */ `

		varying vec2 Uv;

		void main() {

			Uv = uv;
          vec4 modelViewPosition = modelViewMatrix * vec4(position   , 1.0);
        gl_Position = projectionMatrix * modelViewPosition; 
		}`,

    fragmentShader: /* glsl */ `

		uniform vec2 center;
		uniform float angle;
		uniform float scale;
        uniform float time;
        uniform float progress;

		uniform vec2 tSize;

		uniform sampler2D tDiffuse;

		varying vec2 Uv;


		void main() {
            vec2 newuv = Uv  ;
             
            vec2 p = 1. * newuv - vec2(0.8);
            p += 0.4 * cos(scale+1.*p.yx + 1.2 *time + vec2(1.2,3.4));
            p += 0.5 * cos(scale+2.*p.yx + 2. *time + vec2(2.2,4.4));
            p *= 0.9 * cos(scale+3.*p.yx + time + vec2(3.2,1.4));

            p += 0.3 * cos(scale+5.*p.yx + 3.6 * time + vec2(2.2,8.4));



 newuv.x = mix(Uv.x,length(p),progress);
  newuv.y = mix(Uv.y,length(p),progress);

  
  vec4 color = texture2D( tDiffuse ,  newuv );


            gl_FragColor = color ; 
		}`

};

export { custom };